var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "header",
    {
      staticClass:
        "dashboard-header flex items-end justify-between mb-8 font-outfit",
    },
    [
      _c("div", { staticClass: "header-content" }, [
        _c(
          "h1",
          {
            staticClass:
              "text-mobile-heading sm:text-heading font-semibold font-outfit leading-10 mt-4",
          },
          [_vm._v(_vm._s(_vm.title))]
        ),
        _vm.lastUpdated
          ? _c("p", { staticClass: "text-sm text-gray-600" }, [
              _vm._v(" " + _vm._s(_vm.lastUpdated) + " "),
            ])
          : _vm._e(),
      ]),
      _vm.buttonText
        ? _c("UIButton", {
            staticClass: "ml-4 font-outfit",
            attrs: {
              buttonText: _vm.buttonText,
              variant: "black",
              buttonClasses: "px-2 pr-4 pl-4 customHeight40",
            },
            on: { click: _vm.createNewInvoice },
            scopedSlots: _vm._u(
              [
                {
                  key: "icon",
                  fn: function () {
                    return [_c("PlusIcon", { staticClass: "w-6 h-6" })]
                  },
                  proxy: true,
                },
                {
                  key: "hover-icon",
                  fn: function () {
                    return [_c("PlusIcon", { staticClass: "w-6 h-6" })]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3102364802
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }